import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';
import clsx from 'clsx';

export default class GPTReplyModal extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.ticket = this.attrs?.ticket;

    this.explanationField = Stream(this.attrs?.content);
    this.useKnowledgeBase = Stream(true);

    this.onResultPage = false;
    this.aiReply = null;
    this.wasVisible = false;

    this.selectedKnowledgeBaseArticleId = null;

    // Check if it was open
    this.clickAwayListener = (event) => {
      const withinBoundaries = event.composedPath().includes(document.querySelector('#FlarumSupport-AI-modal'));

      if (!withinBoundaries && this.wasVisible) {
        this.attrs?.onClose();
      }
    };
  }

  // Set listener
  oncreate() {
    document.addEventListener('click', this.clickAwayListener);
  }

  // Remove listener
  onbeforeremove() {
    document.removeEventListener('click', this.clickAwayListener);
  }

  // Before updating attributes
  onbeforeupdate(vnode) {
    this.setAttrs(vnode.attrs);

    // If the modal becomes visible, focus textfield
    if (!this.wasVisible && vnode.attrs?.show) {
      this.wasVisible = true;

      setTimeout(() => {
        document.querySelector('#FlarumSupport-gpt-textfield')?.focus();
      }, 50);
    }
    // If becoming invisible, then
    else if (this.wasVisible && !vnode.attrs?.show) {
      this.wasVisible = false;
    }
  }

  // Return view
  view() {
    return (
      <div className={clsx('SupportAiModal', this.attrs?.show && 'Show')} id="FlarumSupport-AI-modal">
        <div className="SupportAiTextfield">
          <textarea
            className="FormControl"
            placeholder={
              'How did you solve the issue? The A.I. will base its response on this fields input. Leave empty to let the A.I. decide how to reply.'
            }
            bidi={this.explanationField}
            disabled={this.loading}
            id="FlarumSupport-gpt-textfield"
            onkeydown={(e) => {
              if (e.which === 13) {
                e.preventDefault();
                this.onsubmit();
              }
            }}
          />
        </div>

        <div className={'SupportAiModalButtons'}>
          {Switch.component(
            {
              state: this.useKnowledgeBase() == true,
              disabled: this.loading,
              size: 'small',
              onchange: (val) => {
                this.useKnowledgeBase(val);
              },
            },
            'Use knowledge base'
          )}

          {Button.component(
            {
              type: 'submit',
              className: 'Button Button--primary SupportModal-save',
              loading: this.loading,
              onclick: () => this.onsubmit(),
            },
            'Generate reply'
          )}
        </div>
      </div>
    );
  }

  onsubmit() {
    this.loading = true;

    app
      .request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/support/ticket/${this.ticket.id()}/generate_reply`,
        body: {
          agentAction: this.explanationField,
          useKnowledgeBase: this.useKnowledgeBase(),
        },
      })
      .then((result) => {
        this.attrs.onReplace(result?.content);
      })
      .catch((response) => this.handleErrors(response))
      .then(() => {
        this.loading = false;

        m.redraw();
      });
  }
}
